var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart-component',{attrs:{"title":_vm.title,"chartOptions":_vm.chartOptions,"chartSeries":_vm.chartSeries},on:{"title-clicked":_vm.onTitleClickedHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }